import { fmtAUD } from '@/shared/utils/formatCurrency';

export function normalizeDesc(desc) {
  return (desc || '')
    .toLowerCase()
    .replace(/\d{2,}/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

function stdDev(values, mean) {
  if (values.length < 2) return 0;
  const variance = values.reduce((s, v) => s + (v - mean) ** 2, 0) / values.length;
  return Math.sqrt(variance);
}

export function detectAnomalies(allTxns, selMonth, selYear, incomeList) {
  const anomalies = new Map();
  const txns = (allTxns || []).filter(
    t => t && t.date && t.category && !(incomeList || []).includes(t.category)
  );

  const currentMonth = [];
  const historical = [];
  for (const t of txns) {
    const d = new Date(t.date);
    if (d.getUTCFullYear() === selYear && d.getUTCMonth() === selMonth) {
      currentMonth.push(t);
    } else {
      historical.push(t);
    }
  }

  // High-amount detection
  const catAmounts = {};
  for (const t of historical) {
    if (!catAmounts[t.category]) catAmounts[t.category] = [];
    catAmounts[t.category].push(Number(t.amount) || 0);
  }

  for (const t of currentMonth) {
    const hist = catAmounts[t.category] || [];
    if (hist.length < 5) continue;
    const mean = hist.reduce((s, v) => s + v, 0) / hist.length;
    const sd = stdDev(hist, mean);
    if (sd === 0) continue;
    const amount = Number(t.amount) || 0;
    const z = (amount - mean) / sd;
    if (z > 2.0 && amount > mean * 1.5 && amount > 50) {
      anomalies.set(t.id, {
        type: 'high-amount',
        message: 'Unusual $' + fmtAUD(amount) + ' in ' + String(t.category) +
          ' (typical: $' + fmtAUD(mean) + ')',
        amount,
      });
    }
  }

  // New-merchant detection
  const historicalNorms = new Set(historical.map(t => normalizeDesc(t.description)));

  for (const t of currentMonth) {
    if (anomalies.has(t.id)) continue;
    const amount = Number(t.amount) || 0;
    if (amount < 30) continue;
    const norm = normalizeDesc(t.description);
    if (norm && !historicalNorms.has(norm)) {
      anomalies.set(t.id, {
        type: 'new-merchant',
        message: 'First time at "' + String(t.description || t.category) +
          '" ($' + fmtAUD(amount) + ')',
        amount,
      });
    }
  }

  return anomalies;
}
